/**
 * @param {Object} productParams
 * @type {any}
 */
window.Designer = Object.assign(window.Designer || {}, {
  version: '20210922',
  creatorUrl: 'https://designer.antigro.com',
  shopifyCartUrl: 'https://www.personalmoments.co.uk/cart',
  langCode: 'en',
  sellerId: 'personalmoments',
  status: {
    notsaved: 'notsaved',
    accepted: 'accepted',
  },
  generateString: function (length) {
    var possibleChars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    var result = '';

    for (var i = 0; i < length; i++) {
      result += possibleChars.charAt(Math.floor(Math.random() * possibleChars.length));
    }

    return result;
  },

  loadCart: function () {
    return fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json;'
      },
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        return cart;
      })
      .catch(function (err) {
        throw err;
      })
  },

  updateCartItem: function (cartItemKey, designerOrderId, designerStatus, quantity) {
    var bodyRaw = {
      id: cartItemKey,
      properties: {
        designerStatus: designerStatus,
        _designerOrderId: designerOrderId,
      },
      quantity: quantity,
    };

    // https://shopify.dev/docs/themes/ajax-api/reference/cart
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;'
      },
      body: JSON.stringify(bodyRaw)
    })
      .then(function (response) {
        return response.json();
      })
  },

  findCartItemByKey: function (itemKey, cart) {
    return cart.items.find(function (item) {
      return item.key === itemKey
    });
  },

  parseGetParams: function (url) {
    var questionmarkIndex = url.indexOf('?');

    if (questionmarkIndex < 0) {
      return {};
    }

    return url.substr(questionmarkIndex + 1).split('&').reduce(function (acc, current) {
      if (current === '') {
        return acc;
      }

      var pair = current.split('=');
      acc[pair[0]] = pair[1];

      return acc;
    }, {});
  },
  /**
   * @param productType np. designer:puzzle-2:szablony-swiateczne
   * @returns {{ }}
   */
  parseProductType: function (productType) {
    var params = productType.split(':');
    var result = {};

    if (params[0] !== 'designer') {
      return;
    }

    if (params.hasOwnProperty(1)) {
      result.productCode = params[1];
    }
    if (params.hasOwnProperty(2)) {
      result.templateBindingType = params[2];
    }
    if (params.hasOwnProperty(3)) {
      result.templateId = params[3];
    }

    return result;
  },

  getReturnUrl: function (designerOrderId) {
    return Designer.shopifyCartUrl + '?designerOrderId=' + designerOrderId + '&designerStatus=' + Designer.status.accepted;
  },

  /**
   *
   * @param productCode
   * @param orderId
   * @param volume
   * @param returnUrl
   * @param templateBindingType
   * @param templateId
   * @returns {string}
   */
  getCreatorLink: function (productCode, orderId, volume, returnUrl, templateBindingType, templateId) {
    var url = Designer.creatorUrl + '/' + Designer.langCode + '/?sellerId=' + Designer.sellerId + '&productCode=' + productCode + '&orderId=' + orderId + '&mode=CUSTOM_INTEGRATION';

    if (volume) {
      url += '&volume=' + volume;
    }
    if (templateBindingType) {
      url += '&templateBindingType=' + templateBindingType;
    }
    if (templateId) {
      url += '&templateId=' + templateId;
    }
    if (returnUrl) {
      url += '&returnUrl=' + encodeURIComponent(returnUrl);
    }

    return url;
  },

  updateCartItemStatusIfNeeded: function () {
    var getParams = Designer.parseGetParams(window.location.href);
    if (!getParams.designerStatus || !getParams.designerOrderId) {
      return;
    }

    Designer.loadCart().then(function (cart) {
      var cartItem = cart.items.find(function (item) {
        return item.properties._designerOrderId === getParams.designerOrderId
      })

      if (!cartItem) {
        return;
      }

      return Designer.updateCartItem(cartItem.key, getParams.designerOrderId, getParams.designerStatus, cartItem.quantity)
        .then(function () {
          // reload cart to remove get params
          window.location.href = Designer.shopifyCartUrl;
        })
    })
      .catch(function (err) {
        console.error(err);
      })
  },

  modifyAddToCartPayload: function (serializedFormData) {
    return serializedFormData.replace('designerOrderIdPlaceholder', Designer.generateString(12));
  },

  /**
   * @param cartItem
   * @param cartItem.key
   * @param cartItem.product_type
   * @param cartItem.quantity
   * @param cartItem.?properties
   * @param cartItem.?properties.?_designerOrderId
   */
  afterAddToCart: function (cartItem) {
    var params = Designer.parseProductType(cartItem.product_type);
    if (!params) {
      return;
    }

    var returnUrl = Designer.getReturnUrl(cartItem.properties._designerOrderId);

    window.location.href = Designer.getCreatorLink(
      params.productCode,
      cartItem.properties._designerOrderId,
      cartItem.quantity,
      returnUrl,
      params.templateBindingType,
      params.templateId,
    );
  },

  onClickCartLink: function (productType, cartItemKey, designerOrderId, quantity) {
    var params = Designer.parseProductType(productType);
    if (!params) {
      return;
    }

    var returnUrl = Designer.getReturnUrl(designerOrderId);

    window.location.href = Designer.getCreatorLink(params.productCode, designerOrderId, quantity, returnUrl, params.templateBindingType, params.templateId,);
    return false;
  },

  modifyUpdateItemQuantityPayload: function (cartItemNode, requestPayload) {
    if (!cartItemNode.dataset) {
      return requestPayload;
    }

    var designerStatus = cartItemNode.dataset.cartItemDesignerStatus;
    var designerOrderId = cartItemNode.dataset.cartItemDesignerOrderId;

    if (designerOrderId) {
      requestPayload.properties = requestPayload.properties || {};
      requestPayload.properties._designerOrderId = designerOrderId;
    }

    if (designerStatus && (designerStatus !== Designer.status.notsaved)) {
      requestPayload.properties = requestPayload.properties || {};
      requestPayload.properties.designerStatus = Designer.status.notsaved;
    }

    return requestPayload;
  },
});

Designer.updateCartItemStatusIfNeeded();
